export default "__VITE_ASSET__ClDihHtN__"